import EventDescription from "../components/EventDescription";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import * as API from "../services/API";
import HeaderMembers from "../headers/headerMembers";
import Footer from "../components/Footer";
import "../css/EventCard.css";

// --------- Event Card ---------

function EventCard({ event, onSelect }) {
  return (
    <div
      className="event-card card border-0 shadow h-100"
      onClick={() => onSelect(event)}
    >
      <div className="event-image-wrapper">
        <img
          src={event.image}
          alt={event.title}
          className="event-image"
        />
        <span className="event-date">
          {new Date(event.start_date).toLocaleDateString("fr-FR")}
        </span>
      </div>

      <div className="card-body d-flex flex-column">
        <h5 className="card-title mb-2">{event.title}</h5>
          <EventDescription className="card-text text-muted flex-grow-1" value={event.description_internal || event.description_general} />
        <span className="event-cta mt-3">
          Voir les détails →
        </span>
      </div>
    </div>
  );
}


// --------- Event Modal ---------

function EventModal({ event, onClose }) {
  if (!event) return null;

  return (
    <Modal
      show
      onHide={onClose}
      centered
      size="lg"
      dialogClassName="event-modal-dialog"
      contentClassName="event-modal-content"
    >
        <button
          className="event-modal-close"
          onClick={onClose}
          aria-label="Fermer"
        >
          ✕
        </button>
      {/* HERO IMAGE */}
      <div className="event-modal-hero">
        <img src={event.image} alt={event.title} />

        <div className="event-modal-hero-overlay">
          <h2>{event.title}</h2>
          <span>📅 {new Date(event.start_date).toLocaleDateString("fr-FR")}</span>
        </div>
      </div>

      {/* CONTENT */}
      <div className="event-modal-body">
        <EventDescription value={event.description_internal || event.description_general} />
      </div>

      {/* FOOTER */}
      <div className="event-modal-footer">
        <Button variant="outline-secondary" onClick={onClose}>
          Fermer
        </Button>
      </div>
    </Modal>
  );
}




// --------- Page ---------

export default function EventsPage() {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [events, setEvents] = useState([]);
    useEffect(() => {
            API.getEvenementAvenirMemberRequest(
                (response)=>{
                    setEvents(response.data);
                },
                ()=>{
                }
                )
            },
            []
            );

  return (
    <>
    <HeaderMembers/>
      <div className="min-vh-100 bg-light bg-gradient">
        <div className="container py-5">
          <h1 className="text-center mb-5 text-dark">
            Évènements à venir
          </h1>

          <div className="row g-4">
            {events.length > 0 ? (
              events.map(event => (
                <div className="col-12 col-md-6 col-lg-4" key={event.id}>
                  <EventCard event={event} onSelect={setSelectedEvent} />
                </div>
              ))
            ) : (
              <p className="text-center text-light">Aucun évènement disponible</p>
            )}
          </div>
        </div>
      </div>
        <Footer/>
      <EventModal event={selectedEvent} onClose={() => setSelectedEvent(null)} />

    </>
  );
}
